
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.69 4.986L7.718 1.605a.5.5 0 00-.437 0L.31 4.987a.498.498 0 000 .9l.933.453c-.005.024-.016.047-.016.073v5.647a.5.5 0 001 0V6.816l1.1.534-.003.018v3.808c0 .088.023.175.068.252.747 1.282 2.237 2.018 4.089 2.018 1.864 0 3.415-.755 4.151-2.018a.508.508 0 00.067-.252V7.345a.019.019 0 00-.002-.007l2.993-1.452a.498.498 0 000-.9zm-3.991 6.048c-.583.886-1.773 1.411-3.218 1.411-1.43 0-2.571-.513-3.157-1.411V7.833l2.958 1.435a.504.504 0 00.436 0l2.981-1.447v3.213zM7.5 8.263L1.673 5.436 7.5 2.61l5.828 2.826L7.5 8.263z"}})])
          )
        }
      }
    